export const useFlueBurnsPageEnabled = (): boolean => {
  return localStorage.getItem("FlueBurnsPage") === "true";
};
